




















import { Prop, Component, Vue, Mixins } from 'vue-property-decorator';
import BaseFluidTile, { IBaseFluidConfiguration } from './BaseFluidTile.vue';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import { N2KFluidLevelEventType, N2KGnssEventType } from '@/common/apis/DeviceApi';

@Component({
    components: {
        BaseFluidTile,
    },
})
export default class BlackWaterLevelTile extends Mixins(TileComponentMixin) {
    @Prop({required: false})
    public configuration?: IBaseFluidConfiguration;

    public type: N2KFluidLevelEventType = N2KFluidLevelEventType.BlackWater;
    public options: CanvasGauges.RadialGaugeOptions = {
        renderTo: this.$refs.canvas as HTMLElement,
        startAngle: 70,
        ticksAngle: 220,
        colorPlate: 'transparent',
        valueBox: false,
        borders: false,
        borderShadowWidth: 0,
        needleShadow: false,
        colorNumbers: '#FFF',
        colorBar: '#CCC',
        fontNumbersSize: 30,
        height: 135,
        width: 135,
        highlights: [],
        colorMajorTicks: '#aaa',
        colorMinorTicks: '#aaa',
    };


}
